import { render, staticRenderFns } from "./PropertyValueAppreciationRate.vue?vue&type=template&id=5e4cdf4c&scoped=true"
import script from "./PropertyValueAppreciationRate.vue?vue&type=script&lang=js"
export * from "./PropertyValueAppreciationRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4cdf4c",
  null
  
)

export default component.exports